export const SET_RESOURCES = 'SET_RESOURCES'
export const SET_RESOURCE = 'SET_RESOURCE'
export const SET_RESOURCE_DATA = 'SET_RESOURCE_DATA'
export const RESET_RESOURCE = 'RESET_RESOURCE'
export const SET_LIBRARYNAME = 'SET_LIBRARYNAME'
export const SET_CHECKED = 'SET_CHECKED'
export const SET_PAGER = 'SET_PAGER'

export const STORE_PAGER = 'resources/pager'
